import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid, Select} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import CommercialTable from '../../../../common/components/commercialTable/commercialTable';
import {DefaultColumnFilter} from '../../../../manageOrders/components/internalCommons/TableFilters';
import WtsCourseAreasModal from './courseAreasModal';
import WtsCourseAreasTechDetailsModal from './courseAreasTechDetailsModal';

const {
  getWtsCoursesAreas,
  updateWtsCoursesArea,
} = Actions;

function WtsCoursesAreas({activeTab}) {
  const wtsCoursesAreas = useSelector((state) => state.wtsCoursesAreas.coursesAreas);
  const areaSelected = useSelector((state) => state.wtsAreas.areaSelected);

  const dispatch = useDispatch();

  useEffect(() => {
    if (areaSelected && activeTab === 2) {
      dispatch(getWtsCoursesAreas(areaSelected.id));
    }
  }, [areaSelected, activeTab]);

  const updateStatus = async(e, checkedValue, item) => {
    e.preventDefault();
    dispatch(updateWtsCoursesArea(areaSelected.id, {
      'data': {
        ...item,
        'status': checkedValue ? 'A' : 'I',
      },
    }));
    dispatch(getWtsCoursesAreas(areaSelected.id));
  };

  const SelectColumnFilter = ({
    'column': {filterValue, setFilter},
  }) => {
    const options = [
      {'key': 'all', 'value': '', 'text': 'TODOS'},
      {'key': 'active', 'value': 'A', 'text': 'ACTIVO'},
      {'key': 'inactive', 'value': 'I', 'text': 'INACTIVO'},
    ];

    return (
      <Select
        compact
        placeholder="TODOS"
        value={filterValue || ''}
        options={options}
        style={{'minWidth': '120px', 'width': '100%'}}
        onChange={(e, {value}) => {
          setFilter(value || '');
          if (!value && areaSelected) {
            dispatch(getWtsCoursesAreas(areaSelected.id));
          }
        }}
      />
    );
  };

  const columns = [
    {
      'Header': () => <span className="header-title">CÓDIGO</span>,
      'accessor': 'id',
    },
    {
      'Header': () => <span className="header-title">AREA</span>,
      'accessor': 'course_area',
    },
    {
      'Header': () => <span className="header-title">CURSOS HABILITADOS</span>,
      'accessor': 'sequence',
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'accessor': 'status',
      'Filter': SelectColumnFilter,
      'filter': (rows, id, filterValue) => {
        if (filterValue === '' || !filterValue) {
          return rows;
        }
        return rows.filter((row) => row.values[id] === filterValue);
      },
      'Cell': (item) => {
        return (
          <Checkbox
            toggle
            checked={item.value === 'A'}
            className='green'
            onChange={(e, input) => updateStatus(e, input.checked, item.row.original)}
          />
        );
      },
    },
    {
      'Header': () => <span className="header-title">ACCIONES</span>,
      'id': 'skills_actions',
      'width': 1,
      'Cell': (item) => {
        return (
          <div className='flex center end'>
            <WtsCourseAreasModal mode='edit' courseAreaToEdit={item.row.original} />
          </div>
        );
      },
    },
  ];

  return (
    <Grid padded>
      <Grid.Row style={{'padding': 0}}>
        <Grid.Column textAlign='left' width={14}>
          <WtsCourseAreasModal mode='new' />
        </Grid.Column>
        <Grid.Column width={2} textAlign='right'>
          <WtsCourseAreasTechDetailsModal />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={10}>
          <CommercialTable
            columns={columns}
            data={wtsCoursesAreas}
            defaultColumnFilter={DefaultColumnFilter}
            defaultPagination={10}
            initialState={{
              'filters': [
                {
                  'id': 'status',
                  'value': '',
                },
              ],
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default WtsCoursesAreas;
